import { Link } from "react-router-dom";
import { useState } from "react";
import { CATEGORIES } from "../lib/categories";
import api from "../lib/api";
import { toast } from "sonner";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("You're subscribed. Welcome to RegenX.");
      setEmail("");
    } catch {
      toast.error("Could not subscribe. Try again later.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <footer className="bg-secondary text-secondary-foreground mt-32" data-testid="site-footer">
      <div className="px-6 md:px-12 lg:px-24 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <h3 className="editorial-heading text-4xl md:text-5xl mb-6">
            Restore. Renew. <span className="text-primary italic">Thrive.</span>
          </h3>
          <p className="text-sm leading-relaxed text-secondary-foreground/70 max-w-md mb-6">
            RegenX Wellness sources, tests, and delivers research-grade peptides for
            independent investigators and laboratories. Every batch is third-party verified.
          </p>
          <form onSubmit={subscribe} className="flex border-b border-secondary-foreground/40 py-2 max-w-md">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              data-testid="footer-newsletter-email"
              className="flex-1 bg-transparent outline-none text-sm placeholder:text-secondary-foreground/40 text-secondary-foreground"
            />
            <button
              type="submit"
              disabled={busy}
              data-testid="footer-newsletter-submit"
              className="uppercase text-[11px] tracking-[0.22em] hover:text-primary transition-colors disabled:opacity-50"
            >
              {busy ? "..." : "Subscribe"}
            </button>
          </form>
        </div>

        <div className="md:col-span-3">
          <p className="overline text-secondary-foreground/50 mb-5">Catalog</p>
          <ul className="space-y-3 text-sm">
            {CATEGORIES.map((c) => (
              <li key={c.slug}>
                <Link
                  to={`/category/${c.slug}`}
                  className="hover:text-primary transition-colors"
                  data-testid={`footer-cat-${c.slug}`}
                >
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="overline text-secondary-foreground/50 mb-5">Company</p>
          <ul className="space-y-3 text-sm">
            <li><Link to="/shop" className="hover:text-primary transition-colors">Shop all</Link></li>
            <li><Link to="/about" className="hover:text-primary transition-colors">About</Link></li>
            <li><Link to="/research" className="hover:text-primary transition-colors" data-testid="footer-research">Research</Link></li>
            <li><Link to="/contact" className="hover:text-primary transition-colors" data-testid="footer-contact">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="overline text-secondary-foreground/50 mb-5">Legal</p>
          <ul className="space-y-3 text-sm">
            <li><Link to="/terms" className="hover:text-primary transition-colors" data-testid="footer-terms">Terms</Link></li>
            <li><Link to="/privacy" className="hover:text-primary transition-colors" data-testid="footer-privacy">Privacy</Link></li>
            <li><Link to="/shipping" className="hover:text-primary transition-colors" data-testid="footer-shipping">Shipping</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-secondary-foreground/15 px-6 md:px-12 lg:px-24 py-6 flex flex-col md:flex-row justify-between gap-3 text-[11px] uppercase tracking-[0.2em] text-secondary-foreground/60">
        <p>© {new Date().getFullYear()} RegenX Wellness · For research use only</p>
        <p>Shipped Australia wide from Melbourne · Third-party tested · 18+</p>
      </div>
    </footer>
  );
}
